<template>
  <div class="generate-step-container" ref="refChatHistoryBox">
    <!-- <div class="generate-step-item generate-step-input-box">
      <div class="generate-step-input" v-if="props.pitem">
        {{
          $$tValue("editor.generate_song_about", {
            song_title: props.item?.title ?? "",
          })
        }}
      </div>
    </div> -->
    <div class="generate-step-item generate-step-result-box flex">
      <!-- <div class="generate-step-avatar flex-center">
        <i class="block icon icon-mureka"></i>
      </div> -->
      <div class="generate-step-result">
        <Showdown
          :markdownText="renderData.markdownText"
          :isWriting="renderData.isWriting"
        ></Showdown>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";

import { useRouter, useRoute } from "vue-router";
import Showdown from "@/components/markdown/showdown.vue";
import useFeedListStore from "@/store/create/feedListDataStore.js";
const feedListDataStore = useFeedListStore();

const Router = (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext?.config?.globalProperties?.$router;
const route = useRoute();
const globalProperties =
  (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext?.config?.globalProperties;
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  pitem: {
    type: Object,
    default: () => ({}),
  },
  markdownText: {
    type: String,
    default: () => {
      return null;
    },
  },
  isWriting: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits([]);
const refChatHistoryBox = ref(null);
const renderData = reactive({
  markdownTextSource: "",
  markdownText: "",
  isWriting: props.isWriting,
});

const setRenderData = () => {
  requestAnimationFrame(() => {
    if (
      renderData.markdownTextSource?.length > renderData.markdownText?.length
    ) {
      renderData.wrighting = true;
      renderData.markdownText += renderData.markdownTextSource.slice(
        renderData.markdownText.length,
        renderData.markdownText.length +
          (Math.random() <= 0.8 ? 0 : Math.floor(Math.random() * 15))
      );
      feedListDataStore.generateStepThinkProcessDataMap[props.pitem.feed_id] = {
        markdownTextSource: renderData.markdownTextSource,
        markdownText: renderData.markdownText,
      };
      onUpdateScroll();
      setRenderData();
    } else {
      renderData.wrighting = false;
      if (props.pitem?.done) {
        renderData.isWriting = false;
      }
    }
  });
};

const onUpdateScroll = (...args) => {
  if (refChatHistoryBox.value) {
    if (
      refChatHistoryBox.value.scrollTop +
        refChatHistoryBox.value.offsetHeight >=
      refChatHistoryBox.value.scrollHeight
    ) {
      nextTick().then(() => {
        refChatHistoryBox.value.scrollTop =
          refChatHistoryBox.value.scrollHeight;
      });
    }
  }
};

watch(
  () => props.pitem,
  (newVal) => {
    renderData.markdownTextSource = props.pitem.content ?? "";
  }
);

onMounted(() => {
  if (props.markdownText != null) {
    renderData.markdownText = props.markdownText;
  } else {
    globalProperties?.logCustomEvent("creative_process_show", {
      tab_stare: "create_generating",
      content_id: props.pitem.feed_id,
    });
    renderData.markdownTextSource = props.pitem.content;
    renderData.markdownText =
      feedListDataStore.generateStepThinkProcessDataMap[props.pitem.feed_id]
        ?.markdownText ?? "";
    setRenderData();
  }
});

watch(
  () => renderData.markdownTextSource,
  (newVal) => {
    if (!renderData.wrighting) {
      setRenderData();
    }
  }
);

watch(
  () => props.markdownText,
  (newVal) => {
    if (props.markdownText) {
      renderData.markdownText = props.markdownText;
    }
  }
);
</script>
<style lang="scss">
.generate-step-container {
  height: 100%;
  border-radius: 8px;
  background: rgba(78, 67, 138, 0.3);
  border: 1px solid #94adff;
  backdrop-filter: blur(10px);
  padding: 10px 10px 10px 10px;
  overflow-y: auto;
  box-sizing: border-box;
  max-height: 100%;
  .generate-step-item {
    &:last-child {
      margin-bottom: 0;
    }
  }
  .generate-step-input-box {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 0 0 8px 10px;
  }
  .generate-step-input {
    border-radius: 6px 6px 0px 6px;
    padding: 8px 12px;
    text-align: right;
    background: rgba(255, 255, 255, 0.3);
    font-family: HarmonyOS Sans SC;
    font-size: 12px;
    color: #ffffff;
  }

  .generate-step-result-box {
    margin: 0 10px 8px 0;
    .generate-step-avatar {
      width: 28px;
      height: 28px;
      background: rgba(148, 173, 255, 0.3);
      margin: 0 8px 0 0;
      border-radius: 50%;
      i {
        height: 14px;
        width: 14px;
        background: url("@/assets/img/mureka-logo-white.png");
        background-size: 100% 100%;
      }
    }
    .generate-step-result {
      flex: 1;
      width: 0;
      min-height: 28px;
    }
  }
}
</style>
